import { useCallback } from 'react'
import { ReactFCC } from '@/types/react'
import { useTranslate } from '@/utils/translate/translate-client'
import { OptionGroup } from '../../components/OptionGroup'

interface AudienceTypesProps {
  disabled?: boolean
  value?: string
  onChange: ({ name, value }: { name: string; value: string }) => void
  name: string
}

export const AudienceTypes: ReactFCC<AudienceTypesProps> = ({ disabled, name, value, onChange }) => {
  const { t } = useTranslate('guild-create')

  const options = [
    {
      label: t('torchAudienceYoungKids', 'Young Kids'),
      value: 'KIDS',
    },
    {
      label: t('torchAudienceTeens', 'Teens'),
      value: 'TEENAGERS',
    },
    {
      label: t('torchAudience', 'Adults'),
      value: 'ADULTS',
    },
  ]

  const handleChange = useCallback(
    (value: string[]) => {
      const [audienceTypeValue] = value

      if (audienceTypeValue === 'KIDS' || audienceTypeValue === 'TEENAGERS') {
        onChange({ name: 'genres', value: 'Children' })
      }
      if (audienceTypeValue === 'TEENAGERS') {
        onChange({ name: 'ages', value: '13-17' })
      }
      if (audienceTypeValue === 'ADULTS') {
        onChange({ name: 'ages', value: '' })
      }

      onChange({ name, value: audienceTypeValue ?? '' })
    },
    [name, onChange],
  )

  return (
    <OptionGroup
      name="audienceType"
      label={t('torchAudienceType', 'Who is the intended audience?')}
      options={options}
      required
      disabled={disabled}
      value={value ? [value] : []}
      onChange={handleChange}
      limit={1}
    />
  )
}
